import { render, staticRenderFns } from "./ViewPurchase.vue?vue&type=template&id=235c1fab&scoped=true&"
import script from "./ViewPurchase.vue?vue&type=script&lang=js&"
export * from "./ViewPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235c1fab",
  null
  
)

export default component.exports